export default {
  config: {
    delimiter: '.',
    separator: ',',
  },
  app: {
    '': '',
    //Terminos globales y usados multiples veces
    actions: 'Ações',
    alerts: 'Alertas',
    register_silobag: 'Registrar Silo Bolsa',
    atention: 'Atenção!',
    battery: 'Bateria',
    language: 'pt-br',
    lots: 'Talhões',
    lot: 'Talhão',
    cancel: 'Cancelar',
    closed: 'Fechado',
    close: 'Fechar',
    partially_extracted: 'Extração parcial',
    copy: 'Copiar',
    continue: 'Continuar',
    organization: 'Organização',
    data: 'Dados',
    companies: 'Empresas',
    company: 'Empresa',
    countryside: 'Estabelecimento',
    countrysides: 'Estabelecimentos',
    cuit: 'CNPJ',
    name: 'Nome',
    original: 'Original',
    state: 'Estado',
    date: 'Data',
    user: 'Usuário',
    role: 'Permissões',
    phone: 'Telefone',
    save: 'Salvar',
    new_silobag: 'Novo Silo Bolsa',
    edit_silobag: 'Editar Silo Bolsa',
    no_user_exists_with_email: 'Não existe usuário com o email:',
    images: 'Imagens',
    modified: 'Modificação',
    no_images: 'Sem imagens',
    observations: 'Observações',
    georeference: 'Georreferência',
    tons: 'Toneladas',
    silobags: 'Silos bolsa',
    return: 'Voltar',
    event: 'Evento',
    stock_movement: 'Movimento de estoque',
    detail: 'Detalhe',
    view_files_attached: 'Ver arquivos anexados',
    without_observations: 'Sem observações',
    method_notifications: 'Método de notificação',
    quality_intermediate: 'Qualidade Intermediária',
    quality_grave: 'Qualidade Grave',
    security: 'Segurança',
    support_calendly: 'Você tem uma sugestão? Agende uma reunião conosco',
    luna_whatsapp: 'Luna',
    support_problem: 'Tenho um problema',
    ubication: 'Localização',
    rows_per_page: 'Linhas por página',
    no_grid_data: 'Não há dados para exibir',
    rows_selected: 'Silos selecionados',
    row_selected: 'Silo selecionado',
    status: 'Estado',
    no_data: 'Não há dados',
    must_field: 'Este campo é obrigatório.',
    no_active_siloid_alerts: 'Neste momento você não possui alertas ativos',
    silobag: 'Silo Bolsa',
    silobag_plural: 'Silos Bolsas',
    quote_silo_insurance: 'Cotar Seguro',
    quote_silo_warrant: 'Cotar warrant',
    quote_silo_iwarrant: 'Cotar iWarrant',
    coming_soon: 'Em breve',
    soon: 'Em breve',
    type: 'Tipo',
    clear_filters: 'Limpar',
    under_construction: 'Em construção.',
    no_connection: 'Não tem conexão com a internet',
    activate: 'Ativar',
    active: 'Ativo',
    system_management: 'Sistema de gestão',
    validated_tons: 'Toneladas validadas',
    siloreales: 'Silos Reais',
    company_name: 'Razão Social',
    yes: 'Sim',
    no: 'Não',
    description: 'Descrição',
    missing_tons:
      'Os silos bolsa sem validação não tiveram seu cadastro realizado ou finalizado em campo utilizando o app',
    missing_tons_title: 'Estão faltando toneladas?',
    register_date: 'Data Alta',
    field_weigth: 'Peso no campo',
    total_extracted_weigth: 'Peso Total extraído',
    slobag_brand: 'Marca deste Silo Bolsa',
    humidity_sources: 'Fonte de umidade',
    fillying_coefficient: 'Coeficiente de preenchimento teórico',
    calculated_coefficient: 'Coeficiente de enchimento calculado',
    silobag_status: 'Estado do SB',
    silobag_data_statuses: 'Validado',
    silobag_lab_protocols: 'Amostras de qualidade',
    diameter: 'Diâmetro',
    lab_protocols_created_at: 'Data da última amostra',
    lab_protocols_closed_date: 'Data final',
    silobag_id: 'ID SB',
    silobag_name: 'Nome SB',
    confirm: 'Confirmar',
    poe_round: 'Vistorias',
    days: 'dias',
    download: 'Baixar',
    downloading: 'Baixando',
    download_all: 'Baixar todos',
    species: 'Cultura',
    choose: 'Selecionar',
    tooltip_sb_selected: 'Selecione pelo menos 1 silo bolsa para exportar',
    tooltip_sb_share_selected: 'Selecione pelo menos 1 silo bolsa para compartilhar',
    see_details: 'Ver detalhes',
    edit_siloreal: 'Editar Siloreal',
    download_certificate_silo: 'Baixar certificado do siloID',
    tooltip_sb_optimo: 'SiloReal em ótimo estado',
    variable: 'Variável',
    mandatory: 'Obrigatório',
    optional: 'Opcional',
    all_silobags: 'Todos os silos bolsa',
    fail: 'apresentaram falhas',
    with_inconsistencies: 'Com inconsistências',
    without_inconsistencies: 'Sem inconsistências',
    whattsapp_icon: 'Precisa de ajuda?',
    beta_badge: 'Funcionalidade em fase BETA: ainda em testes, mas em etapas bastante avançadas',
    siloreal_with_vrr: 'SiloPro com VRR',
    vrr_no_ok_modal: {
      siloreals: 'Os SilosPro',
      siloreal: 'O SiloPro',
      monitored:
        'se encontra sob monitoramento. Caso continua com a operação, a VRR passará ao estado NÃO OK, o que afetará qualquer contrato (CPR, apólice de seguro, originação, forward de grãos) vinculado a este SiloPro.',
      monitored_plural:
        'se encontram sob monitoramento. Caso continua com a operação, a VRR deles passará ao estado NÃO OK, o que afetará qualquer contrato (CPR, apólice de seguro, originação, forward de grãos) vinculado a estes SilosPro',
      irreversible: 'Esta ação é irreversível. Deseja prosseguir com esta operação?',
      accept: 'aceitar',
      accept_writing: 'Escreva "aceitar" para continuar',
    },

    /**--------------------------------------------------------------------------------------------------- */
    navbar: {
      administrator: 'Administrador',
      silobags: 'Silos Bolsa',
      search_silo: 'Encontrar silo',
      organizations: 'Organizações',
      all_organizations: 'Todas as organizações',
      change_password: 'Alterar senha',
      logout: 'Fechar Sessão',
      weather: 'Clima',
      dashboard: 'Dashboard',
      spanish: 'Espanhol',
      language: 'Idioma',
      map: 'Mapa',
      reports: 'Relatórios',
      stock: 'Movimentos de estoque',
      state_stock: 'Condições do estoque',
      existence_stock: 'Verificações de estoque',
      devices: 'Dispositivos',
      device: 'Dispositivo',
      alerts: 'Alertas',
      activity: 'Atividade',
      portuguese: 'Português',
      snack_bar_msj: 'A preferência de idioma foi alterada!',
      alert_value: 'Valor alerta',
      see_all: 'Ver tudo',
      searchbar: {
        searching: 'Buscando silos bolsa...',
        no_results: 'Não existem silos bolsa com estes dados.',
      },
      personalized: 'Personalizado',
      general_position: 'Posição Geral',
      commercial_position: 'Posição Comercial',
      stock_withdrawals: 'Retiradas do Estoque',
    },
    //Pagina de Dashboard
    dashboard_page: {
      welcome_to_field: 'Bem-vindo ao campo inteligente e conectado',
      hi: 'Olá',
      silobags_actives: 'Silos Reais',
      siloreal_alerted: 'Silos Reais com Alertas',
      validated_tons: 'Toneladas Monitoradas',
      non_validated: 'Sem validar',
      non_monitored_validated: 'Toneladas sem validar',
      view_map: 'Visualizar mapa',
      financing: '¡Novas formas de financiamento!',
      know_more: '¡Quero saber mais!',
      maybe_later: 'Talvez mais tarde',
      tons_for_species: 'Toneladas por cultura',
      tons_for_countrysides: 'Toneladas por estabelecimento',
      silobag_lance_sensor: 'Sensores de temperatura, umidade e CO2',
      see_map: 'Ver no mapa',
      countrysides_tooltip: 'São mostrados apenas estabelecimentos com estoque validado em campo',
    },

    // --- ADMIN PAGE --- //
    administrator: {
      title: 'Administrador',
      visualizer: 'Visualizador',
      permission: 'Permissões',
      error_unexpected: 'Ocorreu um erro inesperado.',
      notification: 'Notificações',
      customize_alerts: 'Personalizar alertas',
      Logo_max_size: 'O logotipo não pode exceder o tamanho de 1mb',
      add_logo: 'Adicionar logotipo',
      walkthrough: 'Vistorias',
      new_company: 'Nova empresa',
      new_countryside: 'Novo estabelecimento',
      new_user: 'Novo usuário',
      new_company_toast: 'A empresa foi criada com sucesso.',
      edit_company_toast: 'A empresa foi editada com sucesso',
      not_valid_action: 'A ação não é permitida pois possui SiloIDs vinculados a esta entidade.',
      new_countryside_toast: 'Estabelecimento salvo com sucesso.',
      edit_countryside_toast: 'Estabelecimento editado com sucesso',
      new_user_toast: 'O usuário foi criado com sucesso',
      edit_user_toast: 'O usuário foi editado com sucesso',
      deleted_company: 'A empresa foi eliminada com sucesso',
      deleted_countryside: 'O estabelecimento foi eliminado com sucesso.',
      deleted_user: 'O usuário foi excluído com sucesso.',
      error_delete_countryside: 'A ação não é permitida pois possui SiloIDs vinculados a esta entidade',
      invalid_email: 'E-mail com formato inválido',
      repeted_mail: 'O e-mail já está registrado',
      countryside_zone: 'Regiões',
      warrant_information: 'Informações sobre a empresa',
      warrant_button: 'Carregar dados',
    },
    // --- ADMIN PAGE --- // (integration modal)
    integration_modal: {
      integrations: 'Integrações',
      share_data: 'Compartilhe dados com:',
      apply: 'Ler os',
      terms_conditions: 'termos e Condições',
      system_gestion: 'Sistema de gestão',
      system: 'Sistema',
      login: 'Entrar',
      Albor_username: 'Nome de usuário Albor',
      Albor_password: 'Senha Albor',
      Albor_intergration: 'Integração com Albor',
      Albor_loading: 'Está se conectando ao sistema...',
      Albor_loading2: 'Não feche a janela até que o carregamento esteja completo.',
      albor_title: 'Faça login com sua conta Albor',
      albor_countryside: 'Estabelecimento importado de Albor',
      countryside_warning: 'Localização do estabelecimento importada automaticamente e deve ser corrigida',
      albor_subtitle:
        'Utilize o mesmo endereço de e-mail e senha usados para iniciar sessão na sua conta do Albor.',
      albor_subtitle2: 'para iniciar sessão na sua conta do Albor.',
      albor_joined: 'Sua conta foi conectada com sucesso ao Albor.',
      albor_joined3:
        'La ubicación de los establecimientos se va a tomar directamente de la dirección de Albor por lo que es importante revisar si alguna presenta errores.',
      save: 'Salvar',
      close: 'Fechar',
      integration: 'integração',
      now_you_can:
        'Agora você pode tokenizar seus grãos em silos bolsa e acessar novos instrumentos de financiamento graças à nossa nova integração com Agrotoken.',
      more_info: 'Para mais informações, entre em contato com support@siloreal.com',
      // TIC-4249: integradores autorizados (Nera, etc.)
      integrators_title: 'Empresas com acesso ao seu monitoramento',
      integrators_subtitle:
        'Estas empresas podem consultar o estado de monitoramento dos seus silos bolsa e, se tiverem permissão, ativar o monitoramento por satélite.',
      integrators_empty: 'Nenhuma empresa tem acesso à sua organização.',
      integrators_read: 'Consulta o monitoramento',
      integrators_activate: 'Ativa monitoramento',
      integrators_since: 'desde',
      integrators_no_permissions: 'Sem permissões ativas',
      integrators_source_referral: 'Autorizado no cadastro',
      integrators_source_manual: 'Habilitado pela SiloReal',
      integrators_deactivate: 'Desativar acesso',
      integrators_deactivate_confirm:
        'Desativar o acesso de {client}? Deixará de ver o estado dos seus silos bolsa e de poder ativar monitoramento. Os monitoramentos já ativados continuam vigentes.',
      integrators_deactivated: 'Acesso desativado.',
      integrators_error: 'Não foi possível desativar o acesso. Tente novamente.',
      integrators_forbidden: 'Somente um administrador da organização pode desativar integrações.',
      integrators_revoked: 'desativado em',
    },
    // --- ADMIN PAGE --- // (inspection round modal)
    inspection_round_modal: {
      title: 'Vistoria',
      round_days: 'Dias entre as vistorias',
      question: 'Pergunta',
      ask_for_photo: 'Solicitar foto',
      add_question: 'Adicionar pergunta',
      saved_data: 'Os dados foram salvos com sucesso.',
    },
    countryside_zone_modal: {
      title: 'Regiões',
      name: 'Nome',
      add_zone: 'Adicionar',
      edit_zone: 'Editar',
      name_title: 'Região',
      status_title: 'Ativo',
      name_validation_required: 'O campo é obrigatório',
      name_validation_min_length: 'Insira pelo menos 3 caracteres',
      20049: 'Erro no ID',
      20057: 'Nome da zona já existe',
      20053: 'Organização não encontrada',
      20060: 'Não é possível excluir regiões ativas',
    },
    delete_modal: {
      title: 'Confirmar exclusão',
      question: 'Tem certeza que deseja excluir o registro',
      confirm_delete_button_text: 'Excluir',
      cancel_button_text: 'Cancelar',
    },
    new_edit_silobag: {
      only_numbers: 'Somente números inteiros são aceitos.',
      numbers_decimals: 'Somente números inteiros e decimais são aceitos.',
      less_1000_kg: 'O peso inserido é menor que 1000 KG.',
      only_coords: 'Somente coordenadas válidas são aceitas.',
    },

    company_modal: {
      correct_street: 'Por favor, digite uma rua correta.',
      street: 'Rua',
      Pais: 'País',
      city: 'Cidade',
      zip_code_correct: 'Por favor, insira um CEP correto',
      zip_code: 'CEP',
      cuit_correct: 'Por favor, insira um CNPJ correto.',
      cuit_without_spaces: 'CNPJ sem hífens ou espaços',
      departament_correct: 'Por favor, insira um departamento correto.',
      departament: 'Departamento',
      legal_name_correct: 'Por favor, insira um nome legal correto.',
      legal_name: 'Nome jurídico',
      new_company: 'Nova Empresa',
      correct_number: 'Por favor, digite um número correto.',
      number: 'Número',
      correct_floor: 'Por favor, insira um andar correto.',
      floor: 'Andar',
      locality: 'Bairro',
      email_format: 'Formato de e-mail inválido.',
      duplicated_company: 'A empresa já existe',
      error_data: 'Erro ao carregar os dados',
    },

    user_modal: {
      users: 'Usuários',
      active: 'Ativo',
      correct_dni: 'insira um CPF correto',
      dni: 'CPF',
      ingress_role: 'insira uma função',
      correct_fullname: 'Por favor, insira um nome e sobrenome corretos.',
      fullname: 'Nome e sobrenome',
      phone_correct: 'Por favor, digite um número de telefone correto',
      user_platform: 'Usuário da plataforma',
      permission: 'Permissões',
    },

    countryside_modal: {
      open_map: 'Ver no mapa',
      add_lot: 'Adicionar Talhões',
      city: 'Cidade',
      company: 'Empresa',
      countryside_zone: 'Região',
      discard: 'Descosindere',
      enter_latitude: 'Por favor, insira uma latitude correta.',
      enter_longitude: 'Por favor, insira um comprimento correto.',
      latitude: 'Latitude',
      longitude: 'Longitude',
      lote_no_save: 'talhão sem guardar',
      polygon: 'Polígono',
      geo_position: 'Posição geográfica',
      have_lote_no_save: 'Você tem um lote não salvo. Deseja continuar e descartar o lote?',
      error_data: 'Erro ao carregar os dados',
      duplicated_countryside: 'O estabelecimento já existe',
      duplicated_lot: 'O talhão já existe',
      lots: 'Talhões',
    },
    org_data_admin: {
      org_logo_changed: 'O logotipo da organização foi alterado com sucesso.',
      org_data_changed: 'A organização foi editada com sucesso',
    },

    user_countryside_modal: {
      no_permissions_toast: 'Você não possui permissão para modificar o estabelecimento',
      undefined_permissions: 'Permissões não configuradas',
      invited: 'Convidado',
      going_to_modificate: 'Você está prestes a modificar as permissões da sua própria conta.',
      going_to_modificate_detail:
        'Se você revogar suas permissões de acesso total e confirmar, não será possível reverter a ação a partir desta mesma conta.',
      revert_permission_detail:
        'Se você é o único usuário com acesso total no estabelecimento, a única maneira de revertê-lo será entrando em contato com suporte.',
      inherited: 'Vinculado',
      tooltips: {
        organization_inheritance:
          'As permissões para este estabelecimento estão vinculadas às permissões da organização em que o usuário está cadastrado',
        invited:
          'Usuário externo à organização, com permissões específicas compartilhadas para este estabelecimento',
      },
    },
    //PAGINA LISTADO DE SILOBOLSAS
    silobag_list: {
      banner_title: '¡Temos uma nova versão da lista de silos bolsa!',
      banner_description:
        'Em breve esta lista deixará de estar disponível. Recomendamos que comece a utilizar a nova versão a partir de agora para familiarizar-se com as suas novas funcionalidades',
      your_silobags: 'Seus Silos Bolsa',
      your_siloreales: 'Seus Silos Reais',
      export_data: 'Exportar dados',
      download_data: 'Baixáveis',
      export_all: 'Exportar Tudo',
      export_stock_validate: 'Exportar estoque validado',
      export_view: 'Exportar visualização',
      export_selects: 'Exportar selecionados',
      selected: 'Selecionados',
      export_extraction: 'Exportar extrações',
      download_cma: 'Baixar CMA',
      make_extraction: 'Realizar extração',
      register_silobag: 'Registrar silo bolsa',
      massive_actions: 'Ações em massa',
      masive_register: 'Cadastros em massa',
      quality_samples: 'Amostras de qualidade',
      diameter: 'Diâmetro',
      massive_close: 'Fechamento em massa',
      massive_extraction: 'Extrações em massa',
      close_silobags: 'Fechamentos',
      original_stock:
        'O estoque original é de <b>{{initial_weight}} kg</b> e será fechado com uma diferença de:',
      weight_differential: 'Peso diferencial',
      relation: 'em relação aos <b>{{initial_weight}} kg</b> declarados em seu registro',
      question_close: 'Deseja seguir com o fechamento deste silo bolsa?',
      close: 'Fechamento de silo bolsa',
      silobags: 'Silo bolsas',
      your_stock_total: 'Do seu estoque total',
      charge_page: {
        quality: 'Carregar planilha amostras',
        extraction: 'Carregar planilha extrações',
        register: 'Carregar planilha de cadastros',
        close: 'Carregar planilha fechamentos',
      },
      total_selection: {
        total_info: 'Foram selecionados',
        total_silobags_info: 'silos reais no total',
        total_silobags_selection: 'Selecione todos os SiloIDs ativos',
        deselection: 'Deselecionar todos os SiloIDs ativos',
      },
      download_page: {
        quality: 'Baixar planilha amostras',
        quality_all: 'Baixar tudo',
        extraction: 'Baixar planilha extrações',
        register: 'Baixar planilha de cadastros',
        close: 'Baixar planilha fechamentos',
      },
      search_by_name_id: 'Pesquisar por nome ou ID',
      new_silobag: 'A silo bolsa foi criada com sucesso.',
      non_validated_tons: 'toneladas sem validar',
      non_validated_tons_aclaration:
        'Los silos bolsa sin validar no han sido completados o generados desde el campo utilizando la app',
      bagged_tons: 'Toneladas ensacadas',
      extracted_tons: 'Toneladas extraídas',
      tonnage_difference: 'Diferença de toneladas',
    },
    //TERMINOS DE DATA DE SILOBOLSA
    silobag_data: {
      search_by_name: 'Pesquisar por nome',
      specie: 'Cultura',
      species: 'Culturas',
      view_silo_close: 'Ver silos extraídos',
      view_non_validated_sb: 'Ver silos não validados',
      view_archived_silobags: 'Ver silos arquivados',
      none: 'Nenhum',
      product: 'Produto',
      harvest: 'Safra',
      level_alert: 'Nível de alerta',
      range_storage: 'Período de armazenamento',
      delete_filters: 'Limpar filtros',
      register_date: 'Registro',
      bagging_date: 'Embolsamento',
      bagging_date2: 'Data de embolsamento',
      initial_humidity: 'Umidade inicial',
      close_date: 'Fechando',
      remaining_stock: 'Estoque campo',
      data_main: 'Dados principais',
      additional_data: 'Dados adicionais',
      silobag_init: 'Início silo bolsa',
      silobag_main_photo: 'Foto principal silo bolsa',
      silobag_end: 'Fim silo bolsa',
      silobag_extra_photo: 'Fotos Extras',
      variety: 'Variedade',
      lot_stock: 'talhão Estoque',
      lot_origin: 'talhão Origem',
      lot_origin_1: 'talhão Origem 1',
      lot_origin_2: 'talhão Origem 2',
      lot_origin_3: 'talhão Origem 3',
      weight_lot: 'Peso talhão',
      weight_lot_origin_1: 'Peso talhão Origem 1',
      weight_lot_origin_2: 'Peso talhão Origem 2',
      weight_lot_origin_3: 'Peso talhão Origem 3',
      silobag_size: 'Comprimento embolsado',
      // TIC-3909: dados usados pelas inconsistências v2 (bloco `sat_measurements` do backend)
      sat_verified_section: 'Verificação por satélite (SiloSat)',
      declared_size: 'Comprimento declarado',
      initial_verified_size: 'Comprimento inicial verificado SAT',
      current_verified_size: 'Comprimento atual verificado SAT',
      estimated_initial_weight: 'Peso estimado inicial SAT',
      estimated_current_weight: 'Peso estimado atual SAT',
      estimated_weight_range: 'Faixa {{range}}',
      verified_bagging_date: 'Faixa de embolsamento verificada SAT',
      measured_at: 'Imagem de {{date}}',
      // Tooltips dos checks: ficam no dado declarado (comprimento, peso, estoque e data).
      sat_check_ok: 'Dentro da margem em relação ao estimado pela imagem de satélite',
      length_check_warning: 'O comprimento declarado difere {{pct}} % do comprimento medido por satélite',
      // TIC-3909-3: o peso é validado contra a faixa [min, max] da espécie, sem tolerância.
      weight_check_ok: 'Dentro da faixa estimada pela imagem de satélite',
      weight_check_warning: 'Difere {{pct}} % do peso estimado pela imagem de satélite',
      bagging_date_check_warning:
        'A data declarada está fora da faixa de embolsamento verificada por satélite ({{range}})',
      // Desvio em dias (`bagging_date_diff_days`): mostra-se em valor absoluto, com a direção na
      // própria chave. Singular e plural separados porque estas chaves não usam pluralização.
      bagging_date_diff_before_one: '{{days}} dia antes da faixa verificada',
      bagging_date_diff_before_other: '{{days}} dias antes da faixa verificada',
      bagging_date_diff_after_one: '{{days}} dia depois da faixa verificada',
      bagging_date_diff_after_other: '{{days}} dias depois da faixa verificada',
      sat_image_id: 'Imagem SiloSat #{{id}}',
      sat_image_range_ids: 'Imagens SiloSat #{{before}} e #{{after}}',
      sat_diameter_factor: 'Fator por diâmetro {{factor}}',
      sat_source_bagging_event: 'Evento de embolsamento',
      sat_source_not_available: 'Não disponível',
      weight_bagging: 'Peso embolsado',
      humidity_bagging: '% Umidade inicial',
      lat: 'Latitude',
      long: 'Longitude',
      bagging_responsible: 'Responsável pelo embolsamento',
      diameter: 'Diâmetro (pés)',
      silobag_brand: 'Marca silo bolsa',
      split_grain: '% Avariados',
      varietal_purity: '% Impureza',
      fillying_coefficient: 'Coeficiente de enchimento (Ton/m)',
      fillying_coefficient_no_metrics: 'Coeficiente de enchimento',
      source_humidity: 'Fonte de umidade',
      source_weight: 'Fonte do peso',
      have_breaks: 'Tem quebras?',
      side_charge: 'Silo Bolsa sobre',
      total_extracted: 'Total extraído',
      movement: 'Movimento',
      movements: 'Movimentos',
      quality_serious: 'Grave',
      quality_min: 'Atenção',
      optimun: 'Sem alertas',
      defective: 'Avariados',
      history: 'Histórico',
      devices: 'Dispositivos',
      extractions: 'Extrações',
      metrics: 'Métricas',
      satellite_images: 'Imagens satelitais',
      election_images: 'Escolha as imagens',
      selected_days: 'Dias selecionados',
      existence_silosat: 'Existência',
      existence_images: 'Não há imagens selecionadas',
      size: 'Largura',
      calendar_functionality: 'Funcionamento do calendário:',
      red: 'Vermelho: Prova de inexistência no campo',
      green: 'Verde: Prova de existência em campo',
      white_gray_border: 'Branco com borda cinza: Imagem não analisada',
      no_icon_days: 'Os dias que não têm ícone são aqueles que não têm imagens disponíveis',
      field_selection: 'É necessário selecionar um estabelecimento antes.',
      value_range: 'São aceitos apenas valores entre 0 e 100, e até 2 decimais',
      silobag_diameters: 'São aceitos apenas valores de 5, 6, 8, 9, 10 ou 12',
      only_nums: 'São aceitos apenas números.',
      no_image: 'Sem imagem carregada',
      advanced_filters: 'Filtros avançados',
      inconsistency: 'Inconsistência',
      silo_with_movement: 'Silo com movimento',
      bagging_from: 'Desde o embolsamento ',
      diameter_error: 'O diâmetro está fora do intervalo permitido',
      not_available: 'N/D',
    },

    silobag_devices: {
      new_lance: 'Nova lança',
      instalation_lances: 'Instalação de lanças',
      without_lances: 'Sem lanças',
      with_lances: 'Com lanças',
      number_lance: 'N° Lança/Nome',
      position: 'Posição',
      init: 'Início',
      init_middle: 'Início-Médio',
      middle: 'Médio',
      middle_end: 'Médio-Fim',
      end: 'Fim',
      photo_device: 'Foto do dispositivo',
      confirm_disassociation_lance: 'Confirma a desassociação da lança?',
      last_update: 'Última atualização',
      alert_actives: 'Alertas ativas',
      history: 'Histórico',
      history_alerts: 'Histórico de alertas',
      actions_massive: 'Ações massivas',
    },

    silobag_share: {
      share_silobag: 'Compartilhar silo bolsa',
      ingress_users: 'Ingresse os usuários com quem deseja compartilhar',
      user_access: 'Usuário com acesso',
      type_permission: 'Tipo de permissão',
      user_with_permission: 'Usuário com permissão herdada',
      view: 'Visualizar',
      view_description: 'Você pode visualizar, mas não editar ou compartilhar dados com outros',
      edit: 'Editar',
      edit_description: 'Você pode editar mas ñao compartilhar dados com outros',
      access_complete: 'Acesso completo',
      access_complete_description: 'Você pode editar e compartilhar dados com outros',
      share: 'Compartilhar',
      permissions_share: 'Não possui permissão para compartilhar os seguintes silos bolsa:',
      press_enter_or_space: 'Após escrever o e-mail, pressione "Enter" ou "Espaço".',
      silobag_already_shared: 'O silobag já está compartilhado ou o usuário não existe.',
      silobag_shared: 'Silobag compartilhado com sucesso',
      permissions_updated: 'Permissões atualizadas com sucesso.',
      delete_permission: 'Remover Acesso',
      share_silobag_title: 'Compartilhar',
      cancel_message: 'A operação de compartilhamento de silos bolsas foi cancelada',
      access_information: 'Informação sobre o acesso compartilhado',
      aditional_information: 'Informação adicional',
      permission_change: 'Alteração de permissão ',
      modification_date: 'Data da alteração',
      removed_permission: 'Permissão removida',
      without_access: 'Sem acesso',
      permission_granted: 'Permissão concedida',
      removed: 'Removida',
      shared_externally: 'Compartilhado externamente',
      external_shares_title: 'Compartilhado Externamente',
      shared_silobags: 'Compartilhado apenas este silo bolsa',
      shared_countrysides: 'Compartilhado por Estabelecimento',
      external_email: 'E-mail externo',
      external_organization: 'Organização',
      permission_level: 'Permissão',
      permission_read: 'Leitura',
      permission_write: 'Modificação',
      permission_full: 'Completa',
      permission_none: 'Sem permissão',
    },
    silobags_extractions: {
      silos: 'silos',
      choose_two_silobags: 'Selecione até dois silos bolsa',
      extraction_silobag: 'Registrar Retirada',
      date_withdrawal: 'Data de retirada',
      type_extraction: 'Tipo de retirada',
      truck: 'Caminhão',
      consolidated: 'Consolidado',
      weight_truck: 'Peso Caminhão',
      gross_weight: 'Peso Bruto',
      gross_net_consolidated: 'Peso líquido consolidado',
      net_weight: 'Peso líquido',
      transport: 'Transporte',
      freight_broker: 'Transportadora',
      carrier: 'Transportador',
      driver: 'Motorista',
      chassis_patent: 'Placa Cavalo',
      chassis_attached: 'Placa Carreta',
      others: 'Outros',
      ctg: 'CRG (Código de Rastrerabilidade de grãos)',
      extractions: 'Extrações',
      tara: 'Tara',
      gross: 'Bruto',
      liquid: 'Liquido',
      generic_error_msg: 'Houve um erro ao extrair o peso da silo bolsa.',
      extraction_more_than_doble: 'O peso de extração é mais que o dobro do peso inicial.',
      freight_brok: 'Agente de frete',
      cp: 'CEP',
      contract: 'Contrato',
      extraction_date: 'Data de extração.',
      upload_ARCA_pdf: 'Carregar nota fiscal',
      max_file_weigth: 'Formato PDF/PNG - Máx. 5MB',
      document: 'Documento',
      destination: 'Destino (Comprador)',
      humidity: '% Humidade',
      consignment_note: 'Numero da Nota',
      enter_weight: 'Entrar peso (kg)',
    },
    archived_silobags: {
      title: 'Seus silos arquivados',
      restore: 'Desarquivar silos bolsa',
      count_title: 'Silos arquivados',
      archive: 'Arquivar silos bolsa',
      modal_validation: 'Deseja arquivar os silos bolsa abaixo?',
      archive_button: 'Arquivar',
      modal_permission_question: 'Os seguintes silos não cumprem os requisitos para serem arquivados:',
      modal_restore_question: 'Deseja desarquivar os seguintes silos bolsa?',
      restore_button: 'Desarquivar',
      successful_archiving: 'O silo bolsa foi arquivado com sucesso',
      restored_successful: 'foram corretamente desarquivados.',
      no_restore_permissions: 'Você não possui permissão para desarquivar os seguintes silos bolsa',
      no_silobag_restore: 'Não foi possível desarquivar nenhum silo bolsa',
      no_archived_silobags: 'Não foi possível arquivar nenhum silo bolsa',
    },
    silobag_detail: {
      general_evaluation: 'Avaliação geral',
      next: 'Próximo',
      previous: 'Anterior',
      charge_files: 'Carregar arquivos',
      perform_extraction: 'Realizar extração',
      close: 'Fechar',
      silo_close: 'Silo fechado',
      silobag_version: 'Versão do silo bolsa',
      register_extractions: 'Registro de extrações',
      view_in_map: 'Ver no mapa',
      galery_images: 'Galeria de imagens',
      view_files: 'Ver arquivos',
      file_success: 'O arquivo foi salvo com sucesso',
      file_error: 'Houve um erro ao salvar o arquivo',
      refresh: 'Atualizar',
      weight_extractions: 'Peso extrações',
      difference: 'Diferença',
      difference_percentage: "Diferença '%'",
      edit_silobag: 'O silo bolsa foi editado com sucesso',
      new_extraction: 'Extração concluída com sucesso.',
      edit_extraction: 'A extração do silobag foi atualizada com sucesso.',
      delete_extraction: 'A extração foi removida com sucesso.',
      first_CMC: 'CMC inicial',
      current_CMA: 'CMC atual',
      silosat_date: 'Intervalo aceitável para certificação',
      different_date: 'Inconsistências detectadas na data de embolsamento',
      certification_silosat:
        'Certifica-se que o embolsamento ocorreu entre {{firstVisibleDate}} e {{lastVisibleDate}}',
      different_context:
        'A data declarada durante o registro do silo bolsa não está no intervalo considerado aceitável para a certificação.',
      silosat_size: 'Tamanho SiloSat',
      different_size: 'Diferença no comprimento declarado',
      different_context_size:
        'O comprimento declarado ao registrar o silo bolsa não coincide com o comprimento identificado no SiloSat. Se você deseja certificar esse silo bolsa, é necessário solucionar essa diferença.',
      warning_silosat: 'Inconsistência detectada no SiloSat',
      validated_silosat: 'Comprimento verificado por monitoramento via satélite',
      state_initial: 'Estado inicial',
      tooltip_charge_files: 'Inserir arquivos relevantes para o Siloreal',
      donwload_certificate_history: 'Baixar histórico SiloReal completo',
      download_extractions: 'Baixar planilha de extrações',
      sync_corvus: 'É necessário vincular o Corvus para poder acessar o módulo',
      show_lab: 'Ver e adicionar amostras de qualidade',
      observation_tooltip: 'Não há observações inseridas',
      files_tooltip: 'Não há arquivos anexados',
      id_copied_toast: 'ID copiado com sucesso',
      file_deleted_toast: 'Arquivo excluído corretamente',
      tas_information:
        'Valor calculado com base a parâmetros estabelecidos pelo INTA. Utilizá-lo apenas como referência.',
    },
    silo_sat: {
      images_sat: 'Imagens satelitais',
      without_images: 'Sem imagens satelitais',
      enabling: 'Sem SiloSat. Completar o registro em campo para passar para o próximo estágio.',
      unavailable:
        'Não disponível. Houve algum erro no processo de ativação. Entre em contato com o time de suporte.',
      processing: 'Em ativação. Estamos processando a informação para completar a ativação do serviço.',
      active: 'Ativo',
      available: 'Disponível',
    },
    silobag_metric: {
      metrics: 'Métricas',
      meditions_registered: 'Medições registradas',
      co2: 'Dióxido de Carbono',
      heg: 'Umidade de Equilibrio',
      heg_not_available: 'Não há cálculo HEG para esta espécie.',
    },
    //ETIQUETAR SILOBOLSAS
    silobag_tags: {
      assign: 'Associar etiquetas',
      description: 'As etiquetas te ajudam a organizar e priorizar seus silos bolsa.',
      limit: 'Você pode associar até {{MAX_TAGS}} etiquetas por silo bolsa.',
      question: 'Precisa de uma etiqueta que não está na lista?',
      contact: 'Contacte o administrador da sua empresa para solicitar novas etiquetas.',
      customized: 'Etiquetas personalizadas',
      tags: 'Etiquetas',
      support: 'Contacte o canal de suporte para adicionar as etiquetas à Organização',
      system_tags: 'Etiquetas do sistema',
      organization_tags: 'Etiquetas da organização',
    },
    //PAGINAS DE REPORTES
    report_stock: {
      banner: {
        banner_title: 'Volume atual em estoque',
      },

      stock_report_title: 'Relatórios de Movimentação de Estoque',
      init_date: 'Data inicial',
      close_date: 'Data final',

      initial_balance: 'Volume inicial',
      incomes: 'Entradas',
      income: 'Entrada',
      outcomes: 'Saídas',
      outcome: 'Saída',
      final_balance: 'Volume Final',
      balance: 'Saldo',
      detail: 'Detalhe',
      see_detail: 'Ver Detalhe',
      type: 'Tipo',
      tons_graphic: 'Movimentações',
      balance_graphic: 'Volume em estoque',
      initial_description: 'Montante no início do período selecionado.',
      incomes_description: 'Montante filtrado de entradas.',
      outcomes_description: 'Montante filtrado de saídas.',
      final_description: 'Saldo Inicial + Entradas - Saídas.',
      movement: 'Movimento',
    },

    report_devices: {
      delayed: 'Demorado',
      delete_filters: 'Remover filtros',
      devices_reports_title: 'Relatório de dispositivos',
      installed: 'Instalado',
      last_two_weeks: '14 dias mais recente',
      not_installed: 'Não Instalado',
      not_reporting: 'Não reportando',
      report: 'Relatório',
      reporting: 'Reportando',
      search_device_name: 'Pesquise por nome do dispositivo',
      silo_id: 'Silo ID',
      silobag_name: 'Nome Silo',
      status: 'Instalação',
      totals: 'Totais',
      without_metrics: 'Sem métricas',
      last_transmission: 'Última transmissão',

      deveui_modal: {
        gateway: 'O estado de conexão indica se o Gateway relatou nas últimas duas horas',
        connected: 'Conectado',
        desconnected: 'Desconectado',
        device_detail: 'Detalhe do dispositivo',
        associated_gateway: 'Gateway associado',
        status_connection_gateway: 'Status da conexão do gateway',
        other: 'Outros',
        warning_last_transmission:
          'Os dados mostrados correspondem à última transmissão recebida do sensor. É possível que esta informação não represente o estado atual do mesmo.',
        warning_battery:
          'A métrica sobre a bateria indica o nível de carga da última transmissão. Se o sensor continua enviando dados, mesmo sem estar instalada, é recomendado desligá-la para preservar sua duração.',
      },
    },

    report_activity: {
      title: 'Relatório de Atividade',
    },

    public_pages: {
      login: 'Iniciar sessão',
      register: 'Registro',
      forgot_password: 'Você esqueceu sua senha?',
      more_options: 'Mais opções de início de sessão',
      user: 'Usuário',
      password: 'Senha',
      password_confirm: 'Confirme a senha',
      email: 'E-mail',
      register_question: 'Não tem uma conta? Registro',
      ingress: 'Entrar',
      recover_password: 'Recuperar senha',
      register_company: 'Registro da empresa',
      legal_name: 'Nome jurídico',
      cuit: 'CNPJ',
      fullname: 'Nome completo',
      phone: 'Telefone',
      accept_terms: 'Aceito os termos e condições',
      // TIC-4249: consentimento da integração quando o cadastro vem de um integrador (/go/nera)
      integration_disclaimer:
        'Ao criar sua conta a partir deste link, você autoriza {client} a consultar o estado de monitoramento dos seus silos bolsa e a ativar o monitoramento por satélite sobre eles. Você pode desativar este acesso quando quiser em Administrador → Integrações.',
      create_account: 'Criar conta',
      reset_password: 'Redefinir senha',
      passwords_mismatch: 'As senhas não coincidem',
      register_success: 'Registro bem-sucedido',
      login_fail: 'Usuário ou senha inválidos',
      go_to_login: 'Ir para o login',
      signin_google: 'Entrar com Google',
      signin_microsoft: 'Entrar com Microsoft',
      identify_with_google: 'Identificar-se com Google',
      identified_with_google: 'Identificado com Google',
      identify_with_microsoft: 'Identificar-se com Microsoft',
      identified_with_microsoft: 'Identificado com Microsoft',
      identify_with_microsoft_google_description: 'ou registre-se através de um e-mail',
      signin_classic: 'Entrar com usuário e senha',
      verify_register_title: 'Enviamos um e-mail para você verificar sua conta',
      verify_register_description: 'Por favor, verifique seu e-mail para continuar.',
      verify_register_code: 'Código de verificação',
      verify_reset_account_title: 'Definir ou Redefinir senha',
      verify_reset_account_subtitle: 'Insira o código de verificação que enviamos para o seu e-mail',
      verify_reset_account_error: 'Erro ao verificar o código, verifique se os dados estão corretos',
      verify_reset_account_error_expired:
        'O código de verificação não é mais válido. Por favor, solicite um novo.',
      no_received_code: 'Você não recebeu o código?',
      no_received_code_decription: 'Verifique a caixa de spam ou clique no botão para reenviar',
      policy_privacy: 'Política de privacidade',
      terms_conditions: 'Termos e condições',
      contact: 'Contato',
      error_register:
        'Ocorreu um erro ao tentar registrar a empresa.Por favor verifique se todos os campos foram preenchidos corretamente.',
      error_register_tax_id_exists: 'Erro: o CNPJ informado já está cadastrado',
      error_register_email_exists: 'Erro: o e-mail informado já está cadastrado',
      terms_conditions_error: 'Você deve aceitar os termos e condições para continuar',
      already_client_question: '¿Você já está registrado?',
      already_client: 'Eu sou um cliente',
      verification_code_placeholder: 'Insira o código de verificação',
      toasts: {
        empty_reset_input: 'Houve um erro com os dados',
        success_password_reset: 'Senha renovada com sucesso',
      },
      at_least_eight_characters: 'Deve ter pelo menos 8 caracteres',
      not_exceed_256_characters: 'Não deve exceder os 256 caracteres',
      at_least_one_upper_case: 'Deve ter pelo menos uma letra maiúscula',
      at_least_one_lower_case: 'Deve ter pelo menos uma letra minúscula',
      at_least_one_number: 'Deve ter pelo menos um número',
      at_least_one_special_char: 'Deve ter pelo menos um caractere especial',
    },
    register_silobag_modal_info: {
      missing_countrysides:
        'Um estabelecimento deve ser criado antes de criar silos bolsa. Veja na aba Gerenciado > Estabelecimentos > +Novo Estabelecimento.',
    },
    silobag_edit_modal: {
      explanation: 'Você está editando os dados de um silo bolsa para deixar rastreabilidade no histórico.',
      confirmation: '¿Tem certeza de que deseja confirmar as alterações?',
    },
    silobag_close_modal: {
      silobags: 'Fechamento de Silo bolsas',
      question: 'Deseja continuar com o fechamento dos silos?',
      description: 'Lembre-se de que esta ação não é reversível',
      confirmation: 'Confirmar fechamento',
      permissions: 'Você não tem permissão para fechar silos bolsa',
      silobags_closed: 'Silos bolsa fechados com sucesso',
    },
    silobag_history: {
      extraction: 'Ver Extração',
      resumen: 'Resumo',
      download_file: 'Baixar arquivo',
      no_images: 'Não há imagens para exibir',
      poe_warning: 'A verificação é inválida porque foi realizada a mais de 50 metros do silo bolsa',
      poe_invalid: 'Verificação inválida porque o silo bolsa não foi registrado no campo',
      poe_warning_description:
        'A verificação foi realizada a {{totalDistance}} km do silo bolsa, o máximo para que seja válida é 50 metros.',
      compass: 'Bússola',
      gps_accuracy: 'Precisão GPS',
      reason: 'Razão',
      detail_poe: 'Detalhe da vistorias',
      general_evaluation: 'Avaliação geral',
      description_election: 'Descrição da escolha ou observações',
      breakage: 'Quebras',
      reason_breakage: 'Razão da quebra',
      has_breakage: 'Há Rasgos ou Furos?',
      custom_questions: 'Perguntas personalizadas',
      breakage_register: 'Registro de danos',
      quality_revision: {
        calado: 'Calado',
        sample_type: 'Tipo de amostra',
        silo_position: 'Posição no silo',
        value: 'Valor',
        humidity_measurement: 'Medição da umidade',
      },
      no_observations: 'Não há observações',
      lance_state: 'Condição dos Sensores',
      photo_poe: 'Foto vistorias',

      init_photo: 'Foto início',
      general_photo: 'Foto Geral',
      end_image: 'Foto Fim',
      medition_image: 'Foto Medicion',
      device_image: 'Foto dispositivo',

      photo_breakage: 'Foto do dano',
      photo_question: 'Foto pergunta',
      photo_breakage_resolved: 'Quebra resolvida',
      photo_revition_quality: 'Revisão qualidade',
      photo_detail_siloid: 'Foto detalhe SiloID',
      photo_extra: 'Foto extra',
      Optimum: 'Ótimo',
      precaution: 'Precaução',
      high_risk: 'Risco elevado',
      critical: 'Crítico',
      descriptions: {
        Optimum: 'Não há riscos sobre o silo bolsa, está em boas condições de armazenamento.',
        precaution: 'Há um leve risco sobre o silo bolsa. Está em condições aceitáveis de armazenamento.',
        high_risk:
          'Há um risco elevado sobre o silo bolsa e está em estado de precaução. Está em condições não aceitáveis de armazenamento.',
        critical: 'O silo bolsa está em estado crítico, requer atenção imediata.',
      },
      extraction_confirm: {
        modal_title: 'Detalhes sobre a Extração',
        pre: 'Pré-extração',
        post: 'Pós-extração',
      },
    },
    silobag_action: {
      error_creat_silobag: 'Erro ao criar o silo bolsa',
      invalid_form_message: 'Existem erros no formulário. Por favor, preencha todos os campos obrigatórios',
      close_success: 'Todos os silos bolsa foram fechados com sucesso',
      close_warning: 'Vários silos bolsa foram fechados, mas alguns não foram fechados devido a erros.',
      close_error: 'Os silos bolsa não foram fechados devido a erros.',
      upload_success: 'Todos os silos bolsa foram carregados com sucesso',
      upload_warning: 'Vários silos bolsa foram carregados, mas alguns não foram carregados devido a erros.',
      upload_error: 'Os silos bolsa não foram carregados devido a erros.',
      error_messages: {
        20001:
          'A data está em um formato incorreto. Sugerimos sua revisão e correção. Se o excel está em espanhol ou português o formato é DD/MM/AAAA. Se está em inglês o formato é MM/DD/AAAA',
        20002: 'Cultura não encontrada',
        20003: 'Tipo de produto não encontrado',
        20004: 'Organização não encontrada',
        20005: 'Estabelecimento não encontrado',
        20006:
          'Lote de stock não encontrado, se deseja agregá-lo, acesse a seção de administrador na plataforma web',
        20007: 'Fonte de umidade não encontrada. As opções disponíveis são: "Medição manual" ou "Outra"',
        20008: 'Camion carga sobre não encontrado, as opções corretas são: "Lote" ou "Camino"',
        20009:
          'Fonte de peso não encontrada. As opções disponíveis são: "Corvus", "Bazuca", "Manual" ou "Coeficiente"',
        20010: 'O campo de peso embolsado não pode estar vazio',
        20011: 'O peso embolsado deve ser um número inteiro',
        20012: 'A umidade inicial deve ser um número',
        20013: 'O valor da umidade deve ser um número entre 0 e 100',
        20014: 'A pureza varietal deve ser um número',
        20015: 'O valor da porcentagem de impureza deve ser um número entre 0 e 100',
        20016: 'O valor de porcentagem de defeituosos deve ser um número',
        20017: 'O valor de porcentagem de defeituosos deve ser um número entre 0 e 100',
      },
    },

    siloreal_tutorial: {
      welcome_to_siloreal: 'Bem Vindo à SiloReal',
      step: 'Passo',
      first_title: 'Dashboard',
      first_description:
        'Você poderá visualizar de forma inteligente todos os seus silos bolsa e seus alertas, e assim tomar melhores decisões para seu negócio.',
      map: 'Mapa',
      second_decription:
        'Com a georreferência você poderá localizar facilmente e em tempo real todos os seus ativos',
      third_decription:
        'Substitua suas planilhas por uma lista com filtros para ver seu estoque em campo atualizado.',
      fourth_title: 'Detalhe por silo bolsa',

      fourth_decription:
        'Você poderá dar identidade a cada um dos seus silos bolsa, tendo toda a rastreabilidade em um mesmo lugar.',
      fifth_decription:
        'Tenha o controle de tudo o que acontece através da plataforma e faça a gestão dos silos bolsa com passos simples, administrando suas organizações, estabelecimentos e usuários. ',
      finish: 'Terminar',
      next: 'Seguinte',
      back: 'Voltar',
    },
    notification_page: {
      custom_notifications: 'Personalizar Notificações',
      username: 'Nome de Usuário',
      active_all: 'Ativar todas',
      poe_expired: 'Recorrido: Expirado',
      poe_expired_description:
        'Alerta gerado pelo usuário ao encontrar um silobag em condições de alerta durante um recorrido',
      poe_result: 'Recorrido: Resultado',
      poe_result_description:
        'Alerta gerado pelo vencimento do último recorrido realizado (passaram mais dias entre os recorridos do que o valor configurado)',
      exist_silo_sat: 'Existência SiloSat',
      exist_silo_sat_description: 'Alerta gerado ao não detectar um silobag com imagem de satélite',
      co2: 'Dióxido de Carbono (CO2)',
      co2_description: 'Alerta gerado ao exceder o valor de CO2 permitido para a espécie do silobag',
      mov: 'Movimento (MOV)',
      mov_description: 'Alerta gerado ao detectar movimento de uma sonda',
      heg: 'Umidade (HEG)',
      heg_description: 'Alerta gerado ao exceder o valor de umidade permitido para a espécie do silobag',
      bat: 'Bateria (BAT)',
      bat_description: 'Alerta gerado ao detectar um nível de bateria inferior a 20%',
      quality: 'Qualidade',
      security: 'Segurança',
      tecnical: 'Técnico',
      origin: 'Origem',
      silo_id_tooltip: 'Alertas de resultado de vencimento de percurso',
      silo_sat_tooltip: 'Alertas de existência de serviço satelital',
      silo_metrix_tooltip: 'Alertas de métricas obtidas das lanças do silo bolsa',
      view_detail: 'Ver detalhe',
      desactive_all: 'Desativar todas',
      toast_success: 'Configuração de notificações atualizada',
      validate_phone: 'Validar número de telefone',
      validate_text:
        'Para poder habilitar as notificações SMS ou WhatsApp é necessário validar seu número de telefone.',
      send_sms: 'Enviar SMS',
      phone_validated: 'Número de telefone validado com sucesso',
      phone_invalidated: 'Número de telefone inválido',
      ingress_valid_format: 'Insira um número de telefone válido ',
      warning_modal_title: 'Atenção!',
      warning_modal_text:
        'Para receber as notificações o telefone deverá ser verificado pelo usuário primeiro.',
      confirm_success: ' Número de telefone verificado corretamente.',
      validation_modal_title: 'Enviamos um SMS para validar seu número de telefone',
      validation_modal_text: 'Por favor, insira seu código de verificação',
      warning_phone: 'Ao editar o telefone, será necessário validá-lo novamente.',
      confirm_error: 'Erro ao validar o número de telefone. Formato inválido.',
      button_validate_phone: 'Validar número de telefone',
      confirm_error_code: 'Erro ao validar o número de telefone. Código inválido.',
    },
    not_found: {
      return_dashboard: 'Retornar ao Dashboard',
      return_login: 'Retornar ao Login',
      message: 'Infelizmente, a página que você está procurando não está disponível.',
    },
    state_stock_page: {
      report_state_stock: 'Relatório de Estatus de estoque',
      search_by_name_silo_countryside: 'Buscar SiloID, silo bolsa ou estabelecimento',
      date_bagging: 'Data do embolsamento',
      date_poe: 'Última vistoria',
      result: 'Resultado',
      humidity: 'Umidade',
      aproved: 'Aprovado',
      caution: 'Cuidado',
      risk_elevate: 'Risco Elevado',
      critical: 'Crítico',
      former: 'Antigo:',
      expired: 'Expirado',
      certificate_silo_sat: 'Certificação SiloSat',
      no_certificate_silo_sat: 'Sem certificação SiloSat',
      lance_id: 'ID Lança',
      poe: 'Recorrida',
      position: 'Posição',
      last_metric: 'Medição anterior: ',
      no_last_metric: 'Sem medição anterior',
    },

    map_menu: {
      ubication_copied: 'O local foi copiado com sucesso',
      gallery: 'Galeria',
      back: 'Voltar',
      sat_history: 'Ver histórico',
      siloreales: 'Silos reais',
      cerrar: 'Fechar',
      list: 'Lista',
    },
    map_filters: {
      none: 'Nenhum',
    },
    existence_report_stock: {
      existence_stock_report_title: 'Relatório de Condições do Estoque',
      poe_expired: ' Vistorias expirados',
      visibles: 'Visível',
      not_visibles: 'Não Visível',
      without_images: 'Sem imagens',
      with_movement: 'Com movimento',
      without_movement: 'Sem movimento',
      days_since_last_poe: 'Dias desde a última vistoria',
      result: 'Resultado',
      certainty: 'Certeza',
      last_seven_days: 'Últimos 7 dias',
      movement: 'Movimento',
      last_measurement: 'Métrica mais recente',
      is_visualized: 'Visível',
      not_visualized: 'Não se visualiza',
      without_results: 'Sem Estado',
    },
    silobag_insurance: {
      quote_price: 'Preço/Ton',
      contact:
        'O pedido de cotação foi enviado corretamente, e o responsável da {{enterprise}} entrará em contato em breve.',
      thanks: 'Agradecemos por completar o formulário.',
      request_quote: 'Solicitar Cotação',
      insurable_grains: 'Grãos Asseguráveis',
      provide_details_for_custom_quote: 'Seus dados te permitem elaborar uma cotação de seguro sob medida',
      check_board_quote_price: 'Consultar cotação do preço oficial',
      tons_quoted: 'Toneladas Cotadas',
      month_coverage: 'Cobertura mensal',
      tree_month_coverage: 'Cobertura trimestral',
      six_month_coverage: 'Cobertura semestral',
      annual_coverage: 'Cobertura anual',
      thirds_complete: 'Terceiros Completos',
      sum_assured: 'Soma Assegurada',
      view_detail: 'Ver Detalhe',
      contract: 'Contratar',
      month: 'mês',
      months: 'meses',
      duration_policy: 'Duração da apólice:',
      assured_production: 'Asseguramos a sua produção em',
      crop: 'Cultivo de',
      no_data_month: 'Não há dados de cotação mensal',
      no_data_three_month: 'Não há dados de cotação trimestral',
      no_data_six_month: 'Não há dados de cotação semestral',
      no_data_annual: 'Não há dados de cotação anual',
      your_plan: 'seu plano',
      with: 'com',
      disabled_close_mobile: 'Há pelo menos um SiloReal já fechado em campo: {{ids}}',
      validation: 'Selecione um silobag para ver as opções de seguro',
      enter_price: 'Preencha o campo de Preço/Ton para avançar',
      rus_information:
        'Para que a RUS apareça como empresa para cotação, primeiro se deve selecionar um único silo bolsa.',
      modal_silobag_validation: {
        title: 'Validação de silos bolsas para cotação de seguro',
        description:
          'Algumas das silos bolsa selecionadas não atendem aos requisitos para contratação do seguro.',
        support_message:
          'Se precisar de ajuda para resolver esses erros, por favor entre em contato com nossa equipe de suporte.',
      },
      error_messages: {
        silobag_not_included: 'Não foram incluídos os seguintes silos reais',
        missing_initial_humidity: 'Não estão com a umidade registrada.',
        specie_not_quote: 'Não há disponibilidade de cotações para este tipo de produto.',
        humidity_higher_than_limit: 'O limite de umidade permitido pelas seguradoras foi excedido.',
        has_field_closure: 'São silos bolsa com extração total realizada em campo.',
        silobag_not_in_country: 'Não estão localizados no país da organização.',
      },
      history_modal: {
        title: 'Informações da cotação',
        duration: 'Duração da cobertura',
        sum_assured: 'Total assegurado',
        silobags_assured: 'Silos bolsa assegurados',
        silobag_assured: 'Silo bolsa assegurado',
        general_information: 'Informações gerais',
      },
    },
    integration_corvus: {
      title: 'Integração com Corvus',
      login_corvus: 'Faça login com sua conta Corvus',
      login_corvus_description:
        'Utilize o mesmo endereço de usuario e senha usados para iniciar sessão na sua conta do Corvus.',
      ingress: 'Entrar',
      step: 'Passo',
      vinculate_silobag_corvus: 'Vincular Silobag a AGDP',
      confirm_downloads_corvus: 'Confirme os downloads de Corvus',
      weight_corvus: 'Peso Corvus (kg)',
      warning: 'Lembre- se que se o link for confirmado, o peso que será mantido será o peso corvus',
      vinculate_corvus: 'Vincular Silo bolsa à AGDP',
      confirm_corvus: 'Confirme os downloads do Corvus',
      detail_corvus_title: 'Corvus - detalhe de ligação',
      corvus_weight_certified: 'Peso Corvus Certificado',
      bagging_weight_original: 'Peso de embalagem original: ',
      with: 'com',
      error_login: 'Erro ao fazer login no Corvus, verifique os dados inseridos',
      user: 'Usuário',
      password: 'Senha',
      desvinculate_corvus: 'Desvincular Corvus',
      title_desvinculate: 'Desvinculação completa de downloads',
      success_desvinculate: 'Desvinculação realizada com sucesso!',
      text_desvinculate:
        'Serão desvinculadas todas as descargas deste siloreal, eliminando a certificação do peso embolsado e mostrando o peso declarado antes da vinculação.',
      note_desvinculate: ' Esta alteração será registrada no histórico como ',
      edit_silobag: 'Edição de silo bolsa',
      wet_weight: 'Peso úmido',
      wet: 'Úmido',
      wet_dry: 'Peso seco',
      dry: 'Seco',
    },

    metrics_descriptions: {
      co2: 'Medição de dióxido de carbono (CO2) exibida pelo sensor de lança',
      temp: 'A temperatura mostra a medição pelo sensor de lança',
      heg: 'Umidade de equilíbrio calculada segundo INTA com os valores de umidade relativa, temperatura e espécie',
      hum: 'Umidade intergranária mostrada pela medição do sensor de lança',
      bat: 'Bateria %',
    },
    water_mark: {
      compass: 'Bússola',
      gps: 'Precisão GPS',
      missing_date: 'Data no disponível',
    },
    modal_cmc: {
      register_cmc: 'Registrar SiloID',
      type: 'Tipo',
      date: 'Data',
      download_cmc_initial: 'Baixar SiloID Inicial',
      generate_cmc_update: 'Gerar SiloID Atualizado',
      copy_document_hash: 'Copiar hash do documento',
      copy_transaction_hash: 'Copiar hash da transação',
      download_certificate: 'Baixar certificado',
    },
    countryside_share: {
      share_countryside: 'Compartilhar estabelecimento',
      share_countryside_success: 'Estabelecimento compartilhado com sucesso',
      share_countryside_error: 'O estabelecimento já está compartilhado ou o usuário não existe',
    },
    lab: {
      laboratory: 'Laboratório',
      template_download: {
        tooltip: {
          init: 'É preciso selecionar pelo menos 1 silo bolsa',
          continue: 'Só é possível prosseguir se as culturas selecionadas possuem planilhas disponíveis',
        },
      },
      warning_modal: {
        attention: 'Atenção',
        unavailable:
          'Há {{silosQty}} silo bolsa selecionado cuja cultura não possui um modelo de planilha para carregar as amostras de qualidade.',
        available:
          'Por enquanto as culturas com planilhas disponíveis para realizar a amostra de qualidade são:',
        continue: 'Deseja continuar?',
      },
      upload: {
        success_toast: 'Planilha importada corretamente',
      },
      download_modal: {
        title: 'Planilhas para amostras de qualidade',
      },
      detail_sample_modal: {
        title: 'Amostra de qualidade',
        acquisition_date: 'Data amostra',
        analysis_date: 'Data de análise',
        analysis_number: 'Nro. laude',
        tags: 'Rótulos',
        button: {
          download: 'Baixar nova planilha',
          upload: 'Carregar planilha',
        },
        column_header: {
          field: 'Item',
          result: 'Resultado',
          ref: 'Referência (base e tolerância)',
        },
        no_data: 'Sem dados de amostras',
      },
      success: {
        upload: 'Planilha importada corretamente',
        download: 'Planilha exportada corretamente',
      },
      error: {
        err10019: 'Planilha já importada',
        err10020: 'Esta planilha não corresponde ao silo bolsa selecionado.',
        invalid_file_type: 'Tipo de arquivo inválido.',
        default: 'Ocorreu um erro desconhecido.',
      },
      input_error: {
        required_field: 'Este campo é obrigatório.',
        invalid_value: 'Este valor é inválido.',
        only_numbers: 'São permitidos apenas números.',
        out_of_range: 'Valor fora dos limites permitidos.',
      },
    },
    mobile_close_modal: {
      closure_details_origin: 'Detalhes do fechamento em campo',
      grain_loss: 'Houve alguma perda de grãos no local?',
      area_cleaned: 'A área estava limpa e livre de resíduos plásticos?',
      plastic_recycled: 'O plástico do silo bolsa foi reciclado por uma empresa certificada?',
      closure_distance: 'O fechamento foi realizado a {{distance}} metros do silo bolsa',
      photo_of_area: 'Foto da área',
    },
    alert: {
      state: {
        pending: 'Pendente',
        review: 'Em revisão',
        resolve: 'Solucionado',
        delete: 'Excluir',
      },
      history: {
        footnote: 'Múltiplos status de alertas alterados.',
      },
      modal: {
        title: 'Alteração de status',
        placeholder: {
          main: 'Comentário...',
        },
        single: {
          question: 'Tem certeza de que deseja alterar o status do alerta a ',
        },
        massive: {
          question: 'Tem certeza de que deseja alterar todos os status dos alertas a ',
          warning_title: 'Atenção!',
          warning1:
            '• Você está prestes a realizar uma alteração de status de todos os alertas do menu de alertas ativos.',
          warning2: '• Esta ação pode levar até 2 minutos para ser concluída.',
        },
      },
    },
    delete_extraction: {
      delete: ' Excluir extração',
      confirmation_msg: 'Tem certeza que deseja excluir esta extração?',
    },
    report_position_general: {
      title: 'Relatório de Posição Geral',
    },
    error_screen: {
      something_went_wrong: 'Algo deu errado...',
      error_detected: 'Um erro interno foi detectado durante a operação do sistema.',
      alternatives: 'Aqui estão algumas ações que podem ser úteis para você:',
      support_contact: 'Ou você pode entrar em contato com a equipe de suporte para obter ajuda.',
      button: {
        dashboard: 'Ir para o painel',
        reload: 'Recarregar',
        logout: 'Sair',
        support: 'Suporte',
      },
      toast: {
        copy_error_success: 'Erro copiado com sucesso.',
      },
    },
    nav_bar_bell: {
      button: {
        resolve_all: 'Solucionar todos',
        history: 'Histórico',
      },
      tooltip: {
        only_own_org_resolve:
          'Só é possível resolver alertas em massa da sua organização. Selecione a sua organização através do seletor para continuar.',
        only_own_org_history: 'Só é possível visualizar o histórico da sua organização.',
        no_own_org_alerts: 'Não há alertas ativos na sua organização',
      },
      modal: {
        history_title: 'Histórico de resolução',
        warning_message: 'Tem certeza de que deseja resolver todos os alertas ativos?',
      },
      table: {
        date_header: 'Data e hora',
        user_header: 'Usuário',
        alerts_resolved_qty_header: 'Número de alertas resolvidos',
      },
    },
    image_gallery: {
      title: 'Galeria de imagens',
      no_images: 'Não há imagens disponíveis',
      coords_non_disponible: 'Coordenadas não disponíveis',
    },

    silobags_filters: {
      only_actives: 'Ativos',
      only_inactives: 'Inativos',
    },

    silometrix_threshold: {
      parameterzation_alerts: 'Parametrização de limites para alertas',
      title: 'Limites personalizados do SiloMetrix',
      reset_original_values: 'Redefinir todos os valores padrão',
      count_days_msg: 'Número de dias para resolução automática de alertas de movimento',

      threshold_success: 'As alterações foram salvas com sucesso.',
      threshold_error: 'Erro ao configurar, verifique os dados selecionados.',
      max_100: 'O máximo não pode exceder o igualar 100%',
      min_more_max: 'O valor mínimo não pode exceder o valor máximo.',
      minimun_caution_range: 'Valor de atenção',
      minimun_critic_range: 'Valor máximo tolerável',
      cant_be_0: 'Não pode ser 0',
      reset_list_values: 'Redefinir valores',
      up_to_two_decimals: 'Você só pode inserir até 2 casas decimais',
    },
    inconsistencies_page: {
      inconsistencies: 'Inconsistências',
      gravity: 'Gravidade',
      gravity_low: 'Gravidade baixa',
      gravity_medium: 'Gravidade média',
      gravity_high: 'Gravidade alta',
      totals: 'Total',
      g_low: 'G. baixa',
      g_medium: 'G. média',
      g_high: 'G. alta',
      message: 'Mensagem',
      success_observation: 'Observação adicionada com sucesso',
      detected_inconsistencies: 'Inconsistências detectadas',
      text_modal:
        'Caso você não concorde com os dados fornecidos, compartilhe suas observações para que possamos analisá-las com a equipe de suporte.',
      view_inconsistencies: 'Ver inconsistências',
      severity: 'Gravidade',
      type: 'Tipo de inconsistência',
      DISC_OK: 'Sem inconsistências',
      // TIC-3909: a regra legacy `BAGGING_DATE` (id 1) absorveu a lógica v2 (data declarada contra
      // o intervalo do evento de embolsamento), por isso o texto nomeia o intervalo verificado.
      DISC_BAGGING_DATE_OUT_OF_RANGE: 'Data de embolsamento fora do intervalo verificado por satélite',
      DISC_HARVEST_DATE_OUT_OF_RANGE: 'Safra incompatível',
      DISC_FILLING_FACTOR_OUT_OF_RANGE: 'Coeficiente de enchimento fora do intervalo',
      DISC_NONE_EXISTENCE_EVENT: 'Evento de inexistência',
      // TIC-3909: códigos das regras v2 (comprimento e peso contra a medição por satélite)
      DISC_LENGTH_INCONSISTENCY: 'Comprimento declarado diferente do medido por satélite',
      DISC_INITIAL_WEIGHT_INCONSISTENCY: 'Peso embolsado fora da faixa estimada',
      DISC_CURRENT_WEIGHT_INCONSISTENCY: 'Estoque atual fora da faixa estimada',
      BAGGING_DATE: 'Data de embolsamento',
      BAGGING_DATE_CHECKED: 'Data de embolsamento certificada',
      SAT_BAGGING_START_DATE: 'Data de início de embolsamento SAT',
      SAT_BAGGING_END_DATE: 'Data de fim de embolsamento SAT',
      SAT_CLOSING_DATE: 'Data de fechamento SAT',
      WEIGHT_KG: 'Peso (KG)',
      SIZE_M: 'Comprimento (MTS)',
      DIAMETER_F: 'Diâmetro (PÉS)',
      MIN_FILLING_FACTOR: 'Fator de preenchimento mínimo',
      MAX_FILLING_FACTOR: 'Fator de preenchimento máximo',
      MIN_FILLING_FACTOR_CORRECTED: 'Fator de preenchimento mínimo corregido por diâmetro',
      MAX_FILLING_FACTOR_CORRECTED: 'Fator de preenchimento máximo corregido por diâmetro',
      HARVEST_START_YEAR: 'Ano de colheita mínimo',
      HARVEST_END_YEAR: 'Ano de colheita máximo',
      HAS_CLOSING_EVENT: 'Evento de fechamento',
      HAS_NONEXISTENCE_EVENT: 'Evento de inexistência',
      OVERLAPPED_RAW_DATA: 'Dados sobrepostos',
      view_historical: 'Ver histórico',
      view_active: 'Ver ativo',
      HAS_NONEXISTENCE_EVENT_CREATED_AT: 'Data de criação do evento de inexistência',
      HAS_CLOSING_EVENT_CREATED_AT: 'Data de criação do evento de fechamento',
      // TIC-3909: chaves de `sources` das regras v2. O sub-detalhe traduz uma por uma,
      // então toda chave que o backend persistir precisa de entrada aqui e em es.ts.
      CURRENT_WEIGHT_KG: 'Estoque atual (KG)',
      INITIAL_VERIFIED_SIZE_M: 'Comprimento inicial verificado por satélite (MTS)',
      CURRENT_VERIFIED_SIZE_M: 'Comprimento atual verificado por satélite (MTS)',
      CORRECTION_FACTOR: 'Fator de correção por diâmetro',
      INITIAL_SAT_VIEW_ID: 'Imagem de satélite inicial (ID)',
      INITIAL_SAT_TIMESTAMP: 'Data da imagem de satélite inicial',
      CURRENT_SAT_VIEW_ID: 'Imagem de satélite atual (ID)',
      CURRENT_SAT_TIMESTAMP: 'Data da imagem de satélite atual',
      SAT_IMAGES_COUNT: 'Quantidade de imagens de satélite com comprimento medido',
      INITIAL_LENGTH_SOURCE: 'Origem do comprimento inicial verificado',
      BAGGING_EVENT_ID: 'Evento de embolsamento por satélite (ID)',
      SPECIES_FILLING_FACTOR_TN: 'Coeficiente da espécie aplicado (Ton/m)',
      INITIAL_ESTIMATED_WEIGHT_KG: 'Peso estimado inicial (KG)',
      INITIAL_ESTIMATED_WEIGHT_MIN_KG: 'Peso estimado inicial mínimo (KG)',
      INITIAL_ESTIMATED_WEIGHT_MAX_KG: 'Peso estimado inicial máximo (KG)',
      CURRENT_ESTIMATED_WEIGHT_KG: 'Peso estimado atual (KG)',
      CURRENT_ESTIMATED_WEIGHT_MIN_KG: 'Peso estimado atual mínimo (KG)',
      CURRENT_ESTIMATED_WEIGHT_MAX_KG: 'Peso estimado atual máximo (KG)',
      DECLARED_ESTIMATED_WEIGHT_KG: 'Peso estimado com o comprimento declarado (KG)',
      DECLARED_ESTIMATED_WEIGHT_MIN_KG: 'Peso estimado com o comprimento declarado, mínimo (KG)',
      DECLARED_ESTIMATED_WEIGHT_MAX_KG: 'Peso estimado com o comprimento declarado, máximo (KG)',
      LENGTH_DIFF_PCT: 'Diferença de comprimento (fração)',
      WEIGHT_DIFF_PCT: 'Diferença de peso contra a faixa (fração)',
      TOLERANCE_PCT: 'Tolerância aplicada (fração)',
      MIN_ABS_M: 'Tolerância mínima absoluta de comprimento (MTS)',
      SIZE_M_VALID: 'Comprimento declarado verossímil',
      HAS_EXTRACTION_BEFORE_INITIAL_IMAGE: 'Extrações anteriores à imagem inicial',
      SUSPECTED_FIELD: 'Campo apontado',
      DECLARED_BAGGING_DATE: 'Data de embolsamento declarada',
      SAT_BAGGING_FROM: 'Início da faixa de embolsamento verificada',
      SAT_BAGGING_TO: 'Fim da faixa de embolsamento verificada',
      SAT_BAGGING_BEFORE_SAT_VIEW_ID: 'Imagem de satélite anterior ao embolsamento (ID)',
      SAT_BAGGING_AFTER_SAT_VIEW_ID: 'Imagem de satélite posterior ao embolsamento (ID)',
      TOLERANCE_DAYS: 'Tolerância aplicada (dias)',
      DAYS_OUTSIDE_RANGE: 'Dias fora da faixa verificada',
    },
    massive_register: {
      title: 'Cadastro Massivo de Silos Bolsa',
      description: '¡Você pode completar os dados manualmente ou utilizar sua própria planilha excel!',
      spreadsheet: 'Planilha',
      instructions: 'Instruções',
      content: 'Conteúdo',
      column: 'Coluna',
      required: 'Requisito',
      clarification: 'Esclarecimento',
      exact_match: 'Informação exata',
      example: 'Exemplo',
      free: 'Livre',
      positive_integer: 'Apenas número',
      percentage: 'Porcentagem',
      real_positive_number: 'Valor numérico',
      available_options: 'Opções disponíveis',
      not_available_option_error: 'O valor não coincide com nenhuma das opções disponíveis',
      positive_number_error: 'O valor inserido deve ser um número inteiro positivo (sem decimais)',
      format_date_error:
        'A data possui um formato incorreto. Revisar e corrigir. Utilize o formato padronizado ISO 8601 AAAA/MM/DD',
      integer_number_error: 'O valor inserido não é um número inteiro',
      not_a_number_error: 'O valor inserido não é um número',
      greater_than_1000_error: 'O valor inserido deve ser maior ou igual a 1.000',
      between_0_to_100_error: 'O valor inserido deve estar entre 0 e 100 e deve ter 2 decimais',
      greater_than_0_error: 'O valor inserido deve ser maior que 0',
      modal_title: 'Advertência',
      close_modal_message:
        'Você está prestes a fechar a opção de carga massiva de silos bolsa com dados pendentes. Se fizer isso, todos estes registros serão perdidos.',
      loading_silobags_information: 'Carregando silos bolsa massivamente no sistema',
      mapping_columns_message: 'Quer personalizar as colunas da planilha atual?',
      available_pages: 'Páginas disponíveis',
      when_finish: 'Assim que estiver preenchida, por favor clique em',
      finish: 'Finalizado',
      last_silobags_loaded: 'Últimos silos bolsa cadastrados com sucesso',
      company_description: 'Empresa proprietária do silo bolsa que será cadastrado no sistema',
      countryside_description: 'Estabelecimento ao qual o silo bolsa pertence e/ou se encontra fisicamente',
      silobag_description: 'Nome ou identificação do silo bolsa que será cadastrado no sistema',
      species_description:
        'De qual cultura é o grão ou semente armazenada no silo bolsa que será cadastrado no sistema',
      product_description: 'Tipo de produto que está armazenado GRÃO, SEMENTE, CONSUMO',
      weight_bagging_description: 'Peso total do silo bolsa a ser cadastrado no sistema.',
      lot_stock_description: 'Representa o talhão onde está o silo bolsa que será cadastrado no sistema. ',
      bagging_date_description: 'É a data em que o silo bolsa que será cadastrado no sistema foi embolsado',
      variety_description: 'Detalhe sobre a variedade da cultura armazenada no silo bolsa',
      humidity_bagging_description: 'Umidade inicial do grão no momento de entrada no silo bolsa',
      silobag_size_description: 'Comprimento total do silo bolsa, do início ao fim',
      harvest_description: 'Safra a que pertencem os grãos colhidos e armazenados no silo bolsa',
      origin_lot_description:
        'Talhões onde foram colhidos os grãos colhidos que estão armazenadas no silo bolsa',
      weight_lot_description:
        'O peso do talhão de origem é um dado complementar ao seu nome, com a finalidade de obter a rastreabilidade do produto',
      bagging_responsible_description:
        'Pessoa que realizou a gestão e/ou operação do embolsamento, assumindo a responsabilidade do processo',
      silobag_brand_description: 'Nome da marca fabricante do silo bolsa',
      varietal_purity_description: 'Identificador de Qualidade: Pureza Varietal',
      split_grain_description: 'Identificador de Qualidade: Grãos Quebrados',
      fillying_coefficient_description: 'Coeficiente de enchimento do silo bolsa',
      source_humidity_description:
        'Instrumento ou método pelo qual foi realizada a medição da umidade dos grãos',
      source_weight_description: 'Instrumento ou método pelo qual foi realizada a pesagem dos grãos',
      //side_charge_description: '',
      observations_description: 'Observações a serem registradas e consideradas no futuro',
      company_clarification:
        'O nome da empresa deve ser idêntico ao registrado no sistema. É possível procurar o nome exato da empresa a partir da página de “administrador”. Caso não seja um usuário administrador, entre em contato com um para poder ver as empresas disponíveis',
      countryside_clarification:
        'É possível procurar o nome exato do estabelecimento na página de administrador. Caso não seja um usuário administrador, entre em contato com um para poder ver as empresas disponíveis',
      silobag_clarification:
        'É o nome que identifica o silo bolsa, conforme o procedimiento interno atual. Não é possível deixar este campo vazio. Os nomes dos silos bolsa podem ser repetidos no sistema',
      species_clarification: 'Deve ser uma das opções disponíveis no sistema.',
      product_clarification:
        'Este campo classifica o uso do produto armazenado, e deverá ser preenchido apenas com letras maiúsculas, seguindo as opções de “CONSUMO”, “GRÃO” ou “SEMENTE”',
      weight_bagging_clarification:
        'O peso de entrada deve ser registrado em quilogramas (kg). Deve ser um número inteiro (sem casas decimais), e maior que 1000',
      lot_stock_clarification:
        'Se o talhão ainda não foi cadastrado no sistema, ele será criado automaticamente ao inserir seu nome neste item',
      bagging_date_clarification:
        'El formato de la fecha de embolsado (...)O formato da data de embolsamento deve ser: Ano-Mês-Dia, com o formato AAAA-MM-DD',
      variety_clarification:
        'A variedade é um campo opcional que permite identificar os detalhes sobre a cultura que está armazenada no silo bolsa. Este campo não conta com validações',
      humidity_bagging_clarification:
        'Consiste na umidade registrada no momento de entrada dos grãos ou sementes no silo bolsa. Importante: em caso de adicionar um valor de umidade com casas decimais, utilize um ponto (.) e não uma vírgula (,)',
      silobag_size_clarification:
        'Este campo registra a longitude de cada extremidade do silo bolsa. A medida deverá ser expressa em metros (m)',
      harvest_clarification:
        'A safra é mostrada com a terminação dos últimos números dos anos correspondentes à colheita. É um campo numérico e exato com o padrão: Ano/Ano; com o formato: AA/AA',
      origin_lot_clarification:
        'Este é um campo opcional no sistema, com um limite de dados de três talhões por silo bolsa. Caso os talhões inseridos não tenham sido cadastrados previamente, serão criados novos talhões automaticamente com base nos dados da planilha',
      weight_lot_clarification:
        'Este campo está em processo de desenvolvimento, e por isso não será possível editá-lo até o lançamento de uma nova versão. O peso do talhão de origem é um dado adicional que ajuda a identificar e rastrear a produção. Ele permite determinar a quantidade de grãos colhida em cada talhão específico e que, posteriormente, foi armazenada no silo bolsa. Importante: o peso dos lotes de origem é um dado opcional, e deverá ser expresso em quilogramas (kg)',
      bagging_responsible_clarification: 'Nome do responsável da gestão e/ou operação do embolsamento',
      silobag_brand_clarification:
        'A marca do silo bolsa é registrada para controle estatístico e rastreabilidade',
      varietal_purity_clarification:
        'Valores de laboratório ou de medição em campo que expressam a pureza varietal em porcentagem',
      split_grain_clarification:
        'Valores de laboratório ou de medição em campo que expressam a quantidade de grãos quebrados em porcentagem',
      fillying_coefficient_clarification:
        'É a relação entre o peso do silo bolsa (em kg) e o comprimento do mesmo (em metros)',
      source_humidity_clarification:
        'Pode ser a marca ou o modelo do instrumento, ou até mesmo alguma referência quanto ao método de medição',
      //source_weight_clarification: 'Pode ser a marca ou o modelo do instrumento, ou até mesmo alguma referência quanto ao método de medição',
      //side_charge_clarification: '',
      observations_clarification:
        'Campo aberto para adicionar observações relevantes sobre o produto, seu estado, qualidade ou qualquer outro fator de interesse futuro',
      diameter_clarification: 'O diâmetro normal é 9 pés',
      diameter_description: 'Valores possíveis: 5, 6, 8, 9, 10 ou 12 pés',
    },
    certification_sat: {
      report_sat_certification: 'Relatório de estoque com certificação satelital',
      generate_report: 'Gerar Relatório',
      generate_filter_report: 'Gerar Relatório filtrado',
      pdfName: 'CertificaçãoSatelital',
      error: 'Não foi possível gerar o relatório SiloSat',
    },
  },
};
